<template>
    <div class="Order">
        <div v-if="showSignaturePad" class="signature-modal">
            <div class="signature-modal-content">
                <h3>请在此处签名</h3>
                <canvas ref="signaturePad" width="500" height="300" class="signature-canvas"></canvas>
                <div class="signature-buttons">
                    <el-button @click="saveSignature" type="primary">保存签名</el-button>
                    <el-button @click="clearSignature" type="danger">清除</el-button>
                    <el-button @click="closeSignaturePad">取消</el-button>
                </div>
            </div>
        </div>
        <div class="table-container">
            <el-table 
                v-loading="loading" 
                :data="tableData" 
                @selection-change="handleSelectionChange"
                border
                class="no-wrap-table">
                <el-table-column type="selection" align="center" />
                <!-- <el-table-column prop="id" label="id"></el-table-column> -->
                <el-table-column 
                    cell-class-name="ellipsis-cell" 
                    prop="lbCode" 
                    label="劳务编号"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                        <div class="ellipsis-content">{{ scope.row.lbCode }}</div>
                    </template>
                </el-table-column>
                <el-table-column 
                    cell-class-name="ellipsis-cell" 
                    prop="level" 
                    label="劳务类型"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                        <div class="ellipsis-content">
                            {{ getLevelText(scope.row.level) }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column 
                    cell-class-name="ellipsis-cell" 
                    prop="name" 
                    label="姓名"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                        <div class="ellipsis-content">{{ scope.row.name }}</div>
                    </template>
                </el-table-column>
                <el-table-column 
                    cell-class-name="ellipsis-cell" 
                    prop="phone" 
                    label="电话"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                        <div class="ellipsis-content">{{ scope.row.phone }}</div>
                    </template>
                </el-table-column>
                <el-table-column 
                    cell-class-name="ellipsis-cell" 
                    prop="bankCode" 
                    label="银行卡号"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                        <div class="ellipsis-content">{{ scope.row.bankCode }}</div>
                    </template>
                </el-table-column>
                <el-table-column 
                    cell-class-name="ellipsis-cell" 
                    prop="bankName" 
                    label="开户行"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                        <div class="ellipsis-content">{{ scope.row.bankName }}</div>
                    </template>
                </el-table-column>
                <el-table-column 
                    cell-class-name="ellipsis-cell" 
                    prop="signDate" 
                    label="签署日期"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                        <div class="ellipsis-content">{{ scope.row.signDate }}</div>
                    </template>
                </el-table-column>
                <el-table-column 
                    cell-class-name="ellipsis-cell" 
                    prop="payDate" 
                    label="付款日期"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                        <div class="ellipsis-content">{{ scope.row.payDate }}</div>
                    </template>
                </el-table-column>
                <el-table-column 
                    cell-class-name="ellipsis-cell" 
                    prop="payMoney" 
                    label="金额"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                        <div class="ellipsis-content">{{ scope.row.payMoney }}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="status" label="状态" width="110">
                    <template slot-scope="scope">
                        <el-tag :type="getStatusType(scope.row.status)">
                            {{ getStatusText(scope.row.status) }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="操作" fixed="right" width="200">
                    <template slot-scope="scope">
                        <div class="operation-buttons">
                            <el-button 
                                class="ColorBlue" 
                                size="mini" 
                                @click="handleView(scope.row)">
                                详情
                            </el-button>
                            <el-button 
                                v-if="scope.row.status === 0 || scope.row.status === '0'" 
                                type="primary" 
                                size="mini" 
                                @click="handleSign(scope.row)">
                                去签署
                            </el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <el-dialog :title="isViewMode ? '查看详情' : '编辑信息'" :visible.sync="dialogVisible" width="500px">
            <el-form :model="editForm" label-width="100px">
                <el-form-item label="劳务编号">
                    <el-input v-model="editForm.lbCode" disabled></el-input>
                </el-form-item>
                <el-form-item label="姓名">
                    <el-input v-model="editForm.name" :disabled="isViewMode"></el-input>
                </el-form-item>
                <el-form-item label="电话">
                    <el-input v-model="editForm.phone" :disabled="isViewMode"></el-input>
                </el-form-item>
                <el-form-item label="银行卡号">
                    <el-input v-model="editForm.bankCode" :disabled="isViewMode"></el-input>
                </el-form-item>
                <el-form-item label="开户行">
                    <el-input v-model="editForm.bankName" :disabled="isViewMode"></el-input>
                </el-form-item>
                <el-form-item label="金额">
                    <el-input v-model="editForm.payMoney" :disabled="isViewMode"></el-input>
                </el-form-item>
                <el-form-item label="状态">
                    <el-input :value="getStatusText(editForm.status)" disabled></el-input>
                </el-form-item>
                <el-form-item label="签署日期">
                    <el-date-picker v-model="editForm.signDate" type="date" placeholder="选择日期" :disabled="isViewMode"></el-date-picker>
                </el-form-item>
                <el-form-item label="付款日期">
                    <el-date-picker v-model="editForm.payDate" type="date" placeholder="选择日期" :disabled="isViewMode"></el-date-picker>
                </el-form-item>
                <el-form-item label="协议文件">
                    <div v-if="editForm.serviceFile">
                        <el-button type="text" @click="viewFile(editForm.serviceFile)">查看协议文件</el-button>
                    </div>
                    <div v-else>无协议文件</div>
                </el-form-item>
                <el-form-item label="身份证号">
                    <el-input v-model="editForm.cardNum" disabled></el-input>
                </el-form-item>
                <el-form-item label="身份证正面">
                    <div v-if="editForm.cardFrontFile">
                        <el-button type="text" @click="viewFile(editForm.cardFrontFile)">查看身份证正面</el-button>
                    </div>
                    <div v-else>无身份证正面照片</div>
                </el-form-item>
                <el-form-item label="身份证反面">
                    <div v-if="editForm.cardBackFile">
                        <el-button type="text" @click="viewFile(editForm.cardBackFile)">查看身份证反面</el-button>
                    </div>
                    <div v-else>无身份证反面照片</div>
                </el-form-item>
                <el-form-item label="职称证明">
                    <div v-if="editForm.zhichengFile">
                        <el-button type="text" @click="viewFile(editForm.zhichengFile)">查看职称证明</el-button>
                    </div>
                    <div v-else>无职称证明</div>
                </el-form-item>
                <el-form-item label="资格证书">
                    <div v-if="editForm.zigeFile">
                        <el-button type="text" @click="viewFile(editForm.zigeFile)">查看资格证书</el-button>
                    </div>
                    <div v-else>无资格证书</div>
                </el-form-item>
                <el-form-item label="银行卡照片">
                    <div v-if="editForm.bankFile">
                        <el-button type="text" @click="viewFile(editForm.bankFile)">查看银行卡照片</el-button>
                    </div>
                    <div v-else>无银行卡照片</div>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">{{ isViewMode ? '关闭' : '取消' }}</el-button>
                <el-button v-if="!isViewMode" type="primary" @click="handleSave">确定</el-button>
            </span>
        </el-dialog>
        <!-- 签署流程弹窗 -->
        <el-dialog 
            :title="signStep === 1 ? '填写个人信息' : '签署授权书'" 
            :visible.sync="signDialogVisible" 
            width="1000px"
            :close-on-click-modal="false"
            :destroy-on-close="true"
            :close-on-press-escape="false"
            class="sign-dialog">
            <div class="sign-container">
                <div class="Steps pc-only">
                    <div class="StepsItem" :class="{Act: signStep === 1}">1. 基本信息</div>
                    <div class="StepsItem" :class="{Act: signStep === 2}">2. 授权书签署</div>
                </div>
                <div class="mobile-steps mobile-only">
                    <div class="mobile-step" :class="{active: signStep === 1}">1. 基本信息</div>
                    <div class="mobile-step" :class="{active: signStep === 2}">2. 授权书签署</div>
                </div>

                <!-- 第一步：基本信息 -->
                <div v-if="signStep === 1" class="basic-info">
                    <el-form :model="signForm" label-width="120px" :rules="signRules" ref="signForm">
                        <el-form-item label="姓名" prop="name">
                            <el-input v-model="signForm.name" maxlength="20" placeholder="请输入姓名"></el-input>
                        </el-form-item>
                        <el-form-item label="电话" prop="phone">
                            <el-input v-model="signForm.phone" maxlength="11" placeholder="请输入手机号码"></el-input>
                        </el-form-item>
                        <el-form-item label="身份证号" prop="cardNum">
                            <el-input v-model="signForm.cardNum" maxlength="18" placeholder="请输入身份证号"></el-input>
                        </el-form-item>
                        <el-form-item label="身份证正面照片" prop="cardFrontFile">
                            <div class="custom-upload">
                                <input type="file" ref="cardFrontInput" @change="uploadCardFront" accept="image/jpeg,image/png" style="display:none">
                                <el-button size="small" type="primary" @click="triggerUpload('cardFrontInput')">选择文件</el-button>
                                <div v-if="signForm.cardFrontFile" class="file-info">
                                    <!-- <span class="file-name">{{ signForm.cardFrontFileName }}</span> -->
                                    <el-button type="text" @click="viewFile(signForm.cardFrontFile)">预览</el-button>
                                    <el-button type="text" @click="downloadFile(signForm.cardFrontFile)">下载</el-button>
                                    <img v-if="signForm.cardFrontPreviewUrl" :src="signForm.cardFrontPreviewUrl" class="preview-image" @click="viewFile(signForm.cardFrontFile)" />
                                </div>
                                <!-- <div v-else class="upload-tip">请上传身份证正面照片，仅支持JPG/PNG格式，文件大小不超过500KB</div> -->
                            </div>
                        </el-form-item>
                        <el-form-item label="身份证反面照片" prop="cardBackFile">
                            <div class="custom-upload">
                                <input type="file" ref="cardBackInput" @change="uploadCardBack" accept="image/jpeg,image/png" style="display:none">
                                <el-button size="small" type="primary" @click="triggerUpload('cardBackInput')">选择文件</el-button>
                                <div v-if="signForm.cardBackFile" class="file-info">
                                    <!-- <span class="file-name">{{ signForm.cardBackFileName }}</span> -->
                                    <el-button type="text" @click="viewFile(signForm.cardBackFile)">预览</el-button>
                                    <el-button type="text" @click="downloadFile(signForm.cardBackFile)">下载</el-button>
                                    <img v-if="signForm.cardBackPreviewUrl" :src="signForm.cardBackPreviewUrl" class="preview-image" @click="viewFile(signForm.cardBackFile)" />
                                </div>
                                <!-- <div v-else class="upload-tip">请上传身份证反面照片，仅支持JPG/PNG格式，文件大小不超过500KB</div> -->
                            </div>
                        </el-form-item>
                        <el-form-item label="银行卡号" prop="bankCode">
                            <el-input v-model="signForm.bankCode" maxlength="19" placeholder="请输入银行卡号"></el-input>
                        </el-form-item>
                        <el-form-item label="开户行" prop="bankName">
                            <el-input v-model="signForm.bankName" maxlength="50" placeholder="请输入开户行名称（具体到支行）"></el-input>
                            <div style="color: #FF4949; font-size: 12px; margin-top: 5px;">示例：招商银行北京支行</div>
                        </el-form-item>
                        <el-form-item label="开户行地址省" prop="bankProvince">
                            <el-input v-model="signForm.bankProvince" maxlength="20" placeholder="请输入开户行地址省"></el-input>
                        </el-form-item>
                        <el-form-item label="开户行地址市" prop="bankCity">
                            <el-input v-model="signForm.bankCity" maxlength="20" placeholder="请输入开户行地址市"></el-input>
                        </el-form-item>
                        <el-form-item label="银行卡照片">
                            <div class="custom-upload">
                                <input type="file" ref="bankFileInput" @change="uploadBankFile" accept="image/jpeg,image/png" style="display:none">
                                <el-button size="small" type="primary" @click="triggerUpload('bankFileInput')">选择文件</el-button>
                                <div v-if="signForm.bankFile" class="file-info">
                                    <!-- <span class="file-name">{{ signForm.bankFileName }}</span> -->
                                    <el-button type="text" @click="viewFile(signForm.bankFile)">预览</el-button>
                                    <el-button type="text" @click="downloadFile(signForm.bankFile)">下载</el-button>
                                    <img v-if="signForm.bankPreviewUrl" :src="signForm.bankPreviewUrl" class="preview-image" @click="viewFile(signForm.bankFile)" />
                                </div>
                                <!-- <div v-else class="upload-tip">请上传银行卡照片，仅支持JPG/PNG格式，文件大小不超过500KB</div> -->
                            </div>
                        </el-form-item>
                        <el-form-item label="劳务金额">
                            <el-input v-model="signForm.payMoney" disabled></el-input>
                        </el-form-item>
                        <el-form-item label="工作单位" prop="workUnit">
                            <el-input v-model="signForm.workUnit" maxlength="50" placeholder="请输入工作单位"></el-input>
                        </el-form-item>
                        <el-form-item label="医务职称" prop="title">
                            <el-input v-model="signForm.title" maxlength="20" placeholder="请输入医务职称"></el-input>
                        </el-form-item>
                        <el-form-item label="所属科室" prop="department">
                            <el-input v-model="signForm.department" maxlength="30" placeholder="请输入科室"></el-input>
                        </el-form-item>
                        <el-form-item label="职称证明" prop="zhichengFile">
                            <div class="custom-upload">
                                <input type="file" ref="zhichengFileInput" @change="uploadZhichengFile" accept="image/jpeg,image/png" style="display:none">
                                <el-button size="small" type="primary" @click="triggerUpload('zhichengFileInput')">选择文件</el-button>
                                <div v-if="signForm.zhichengFile" class="file-info">
                                    <!-- <span class="file-name">{{ signForm.zhichengFileName }}</span> -->
                                    <el-button type="text" @click="viewFile(signForm.zhichengFile)">预览</el-button>
                                    <el-button type="text" @click="downloadFile(signForm.zhichengFile)">下载</el-button>
                                    <img v-if="signForm.zhichengPreviewUrl" :src="signForm.zhichengPreviewUrl" class="preview-image" @click="viewFile(signForm.zhichengFile)" />
                                </div>
                                <!-- <div v-else class="upload-tip">请上传职称证明，仅支持JPG/PNG格式，文件大小不超过500KB</div> -->
                            </div>
                        </el-form-item>
                        <el-form-item label="资格证书">
                            <div class="custom-upload">
                                <input type="file" ref="zigeFileInput" @change="uploadZigeFile" accept="image/jpeg,image/png" style="display:none">
                                <el-button size="small" type="primary" @click="triggerUpload('zigeFileInput')">选择文件</el-button>
                                <div v-if="signForm.zigeFile" class="file-info">
                                    <!-- <span class="file-name">{{ signForm.zigeFileName }}</span> -->
                                    <el-button type="text" @click="viewFile(signForm.zigeFile)">预览</el-button>
                                    <el-button type="text" @click="downloadFile(signForm.zigeFile)">下载</el-button>
                                    <img v-if="signForm.zigePreviewUrl" :src="signForm.zigePreviewUrl" class="preview-image" @click="viewFile(signForm.zigeFile)" />
                                </div>
                                <!-- <div v-else class="upload-tip">请上传资格证书，仅支持JPG/PNG格式，文件大小不超过500KB</div> -->
                            </div>
                        </el-form-item>
                        <el-form-item label="签署日期" prop="signDate">
                            <el-date-picker 
                                v-model="signForm.signDate" 
                                type="date" 
                                placeholder="选择日期"
                                value-format="yyyy-MM-dd">
                            </el-date-picker>
                        </el-form-item>
                    </el-form>
                </div>

                <!-- 第二步：授权书签署 -->
                <div v-else class="auth-content">
                    <div class="authorization-form" ref="authorizationContainer">
                        <h2 class="agreement-title">北京整合医学学会学术活动劳务协议</h2>
                        <div class="agreement-header">
                            <p>甲方：北京整合医学学会</p>
                            <p>乙方：<span class="text-placeholder">{{ signForm.name }}</span></p>
                        </div>

                        <div class="agreement-section">
                            <h3>第一条：合规范围</h3>
                            <p class="indent">北京整合医学学会是经北京市民政局批准的学术性社会组织，主要从事开展整合医学领域的学术研究、学术交流、专业培训、展览展示、咨询服务、会议服务、对外交流、承办委托等。学会涉及的主要活动为举办医学学术讲座、交流会、研讨会等；专项资助医药卫生领域的科学研究；面向基层，开展赋能教育培训和健康科普；开展医学相关咨询服务，承办政府相关委托；组织会员参与、开展公益性医疗帮扶，义诊活动；组织专家讨论，形成医学专家共识、指南。</p>
                        </div>

                        <div class="agreement-section">
                            <h3>第二条：协议内容</h3>
                            <div class="sub-section">
                                <p>(一) 甲方权利义务</p>
                                <p class="indent">1、甲方有权要求乙方按时按质完成本协议项下约定的作品评审活动。</p>
                                <p class="indent">2、乙方提供相关作品评审后，经甲乙双方签字确认，甲方以银行转账的形式支付乙方劳务报酬。</p>
                                <p class="indent">3、代扣代缴个人所得税。</p>
                            </div>
                            <div class="sub-section">
                                <p>(二) 乙方权利义务</p>
                                <p v-if="level === 3" class="indent">1、乙方应甲方邀请，就甲方资助/举办的"百姓巡常行"项目按约定对征集作品进行评审。切实帮助甲方或者甲方指定的受众提高专业知识认知，普及健康知识，助力全民健康素养水平的提升。乙方应恪守专业勤勉的精神，认真按时完成协议约定的活动。</p>
                                <p v-if="level === 1" class="indent">1、乙方应甲方邀请，就甲方资助/举办的作品征集按约定分享专业知识和专业经验。切实帮助甲方或者甲方指定的受众提高专业知识认知，普及健康知识，助力全民健康素养水平的提升。乙方应恪守专业勤勉的精神，认真按时完成协议约定的活动。</p>
                                <p v-if="level === 3" class="indent">2、乙方保证获得了所需的所有审批和许可，包括但不限于向所属单位被聘参与作品评审的服务内容及获酬情况等。</p>
                                <p v-if="level === 1" class="indent">2、乙方特授予甲方、项目平台、北京整合医学学会官网、公众号、项目组相关渠道及指定平台一项永久性的免费授权，以将含有乙方肖像的作品放在上述平台上，包括使用乙方肖像在其他媒体或平台上用于上述作品的宣传活动及本项目的相关宣传。</p>
                                <p class="indent">3、合作双方均了解中国及境外关于反商业贿赂、反腐败的相关法律法规，并承诺本协议涉及内容不违反相关内容。</p>
                                <p class="indent">4、乙方知晓且同意，为订立和履行本协议必需之目的，学会及选定的付款、平台的第三方合作伙伴和会议协办方将收集、使用、处理、储存专家的个人信息，包括但不限于专家姓名、身份证号、银行账户信息、个人联系方式等。学会将按照相关的法律、法规对本协议项下的个人信息进行处理。</p>
                                <p class="indent">5、乙方知晓并确认，其作品内容将被其他医疗卫生专业人士、患者所学习并应用。乙方应对其作品内容的准确性承担责任。</p>
                            </div>
                        </div>

                        <div class="agreement-section">
                            <h3>第三条：乙方提供的学术活动相关劳务服务内容：</h3>
                            <p class="indent">甲方于<span class="underline">2025</span>年<span class="underline">3</span>月至2025年12月举办的<span class="underline"> 健康中国行动-百姓健康卫士公益科普"百姓巡常行"</span></p>
                            <p v-if="level === 3" class="indent">作品征集活动 中邀请您参与<span class="underline"> 科普短视频 / 科普讲座 / 科普图画 / 科普文章 </span>作品评审。</p>
                            <p v-if="level === 1" class="indent">作品征集活动 中邀请您参与<span class="underline"> {{ getWorksTypeText(signForm.worksType) }} </span> 作品征集。</p>
                            <p v-if="level === 1" class="indent">作品名称为：<span class="underline works-name">{{ signForm.worksName }}</span></p>
                        </div>

                        <div class="agreement-section payment-info">
                            <p>支付信息如下：</p>
                            <div class="info-grid">
                                <div class="info-row">
                                    <p>协议费用总额（税前、√ 税后）￥<span class="text-placeholder">{{ signForm.payMoney }}</span>（元）</p>
                                </div>
                                <div class="info-row payment-double-row name-phone-row">
                                    <p class="left-info">账户名称（持卡人姓名）：<span class="text-placeholder">{{ signForm.name }}</span></p>
                                    <p class="right-info">手机号码：<span class="text-placeholder">{{ signForm.phone }}</span></p>
                                </div>
                                <div class="info-row payment-double-row id-card-row">
                                    <p class="left-info">身份证号（外籍填写护照号）：<span class="text-placeholder">{{ signForm.cardNum }}</span></p>
                                    <p class="right-info">银行卡号：<span class="text-placeholder">{{ signForm.bankCode }}</span></p>
                                </div>
                                <div class="info-row payment-double-row bank-card-row">
                                    <p class="left-info">开户银行名称（具体到支行）：<span class="text-placeholder">{{ signForm.bankName }}</span></p>
                                    <p class="right-info">医务职称：<span class="text-placeholder">{{ signForm.title }}</span></p>
                                </div>
                                <div class="info-row">
                                    <p>工作单位：<span class="text-placeholder">{{ signForm.workUnit }}</span></p>
                                </div>
                            </div>
                        </div>

                        <div class="agreement-footer">
                            <div class="signature-row">
                                <div class="signature-col left-signature">
                                    <p>甲方（盖章）：北京整合医学学会</p>
                                    <p>日期：<span class="text-placeholder">{{ currentDate }}</span></p>
                                </div>
                                <div class="signature-col right-signature">
                                    <p>乙方确认签字（手签）：
                                        <span class="signature-area" @click="handleSignClick">
                                            <img v-if="signatureImage" :src="signatureImage" alt="签名" class="signature-image"/>
                                            <span v-else class="signature-placeholder">点击此处签名</span>
                                        </span>
                                    </p>
                                    <p>日期：<span class="text-placeholder">{{ currentDate }}</span></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 底部按钮 -->
                <div class="dialog-footer">
                    <el-button @click="signDialogVisible = false" :disabled="pdfLoading">取消</el-button>
                    <el-button v-if="signStep === 1" type="primary" @click="nextStep" :disabled="pdfLoading">下一步</el-button>
                    <el-button v-else type="primary" @click="submitSign" :loading="pdfLoading">提交</el-button>
                </div>
            </div>
        </el-dialog>

        <div class="PageDis">
            <el-pagination background :page-sizes="[10, 20, 50]" layout="prev,pager,next,total,sizes"  @size-change="SizeChange" @current-change="PageChange" :total="total" :current-page="page" :hide-on-single-page="false"></el-pagination>
        </div>
    </div>
</template>

<script>
    import { checkTokenExpiration, clearLoginInfo } from '@/utils/auth'
    import SignaturePad from 'signature_pad'
    import html2canvas from 'html2canvas'
    import { jsPDF } from 'jspdf'
    import html2pdf from 'html2pdf.js'
    import axios from 'axios'

    export default {
        data() {
            return {
                loading: false,
                i: 1,
                tableData: [],
                total: 0,
                page: 1,
                SizePage: 10,
                dialogVisible: false,
                signDialogVisible: false,
                signStep: 1,
                level: 1,
                pdfLoading: false,
                signForm: {
                    id: '',
                    name: '',
                    phone: '',
                    cardNum: '',
                    cardFrontFile: '',
                    cardBackFile: '',
                    bankCode: '',
                    bankFile: '',
                    bankName: '',
                    bankProvince: '',
                    bankCity: '',
                    workUnit: '',
                    title: '',
                    department: '',
                    zhichengFile: '',
                    zigeFile: '',
                    payMoney: '',
                    signDate: '',
                    signature: '',
                    lbCode: '',
                    projectId: '',
                    worksid: '',
                    worksName: ''
                },
                signRules: {
                    name: [
                        { required: true, message: '请输入姓名', trigger: 'blur' }
                    ],
                    phone: [
                        { required: true, message: '请输入电话', trigger: 'blur' },
                        { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
                    ],
                    cardNum: [
                        { required: true, message: '请输入身份证号', trigger: 'blur' }
                    ],
                    bankCode: [
                        { required: true, message: '请输入银行卡号', trigger: 'blur' },
                        { pattern: /^\d{16,19}$/, message: '请输入正确的银行卡号', trigger: 'blur' }
                    ],
                    bankName: [
                        { required: true, message: '请输入开户行', trigger: 'blur' }
                    ],
                    cardFrontFile: [
                        { 
                            required: true, 
                            validator: (rule, value, callback) => {
                                if (!this.signForm.cardFrontFile) {
                                    callback(new Error('请上传身份证正面照片'));
                                } else {
                                    callback();
                                }
                            },
                            trigger: 'change'
                        }
                    ],
                    cardBackFile: [
                        { 
                            required: true, 
                            validator: (rule, value, callback) => {
                                if (!this.signForm.cardBackFile) {
                                    callback(new Error('请上传身份证反面照片'));
                                } else {
                                    callback();
                                }
                            },
                            trigger: 'change'
                        }
                    ],
                    bankProvince: [
                        { required: true, message: '请输入开户行地址省', trigger: 'blur' }
                    ],
                    bankCity: [
                        { required: true, message: '请输入开户行地址市', trigger: 'blur' }
                    ],
                    workUnit: [
                        { required: true, message: '请输入工作单位', trigger: 'blur' }
                    ],
                    title: [
                        { required: true, message: '请输入医务职称', trigger: 'blur' }
                    ],
                    department: [
                        { required: true, message: '请输入科室', trigger: 'blur' }
                    ],
                    zhichengFile: [
        { 
            required: true, 
            validator: (rule, value, callback) => {
                if (!this.signForm.zhichengFile) {
                    callback(new Error('请上传职称证明'));
                } else {
                    callback();
                }
            },
            trigger: 'change' // 改为 'change' 确保文件上传后触发验证
        }
                    ],
                    signDate: [
                        { required: true, message: '请选择签署日期', trigger: 'change' }
                    ]
                },
                signaturePad: null,
                editForm: {
                    id: '',
                    ldcode: '',
                    name: '',
                    phone: '',
                    bankCode: '',
                    bankName: '',
                    signDate: '',
                    payDate: '',
                    payMoney: '',
                    status: '0',
                    serviceFile: '',
                    cardNum: '',
                    cardFrontFile: '',
                    cardBackFile: '',
                    zhichengFile: '',
                    bankFile: ''
                },
                multipleSelection: [],
                isViewMode: false,
                currentDate: '',
                signatureImage: '',
                showSignaturePad: false,
                canvasOffset: { left: 0, top: 0 }
            }
        },
        created() {
            this.getServiceList();
        },
        mounted() {
            // 初始化签名板
            this.$nextTick(() => {
                if (this.$refs.signaturePad) {
                    this.signaturePad = new SignaturePad(this.$refs.signaturePad, {
                        backgroundColor: 'rgba(255, 255, 255, 0)',
                        penColor: 'rgb(0, 0, 0)'
                    });
                }
            });
        },
        methods: {
            // 获取状态文字
            getStatusText(status) {
                // 将状态转换为数字以确保正确匹配
                const statusNum = parseInt(status);
                const statusMap = {
                    0: '待签署',
                    1: '已签署待付款',
                    2: '已付款',
                     3: '待通知',
                     4: '异常'
                };
                return statusMap[statusNum] !== undefined ? statusMap[statusNum] : status;
            },

            // 获取状态类型
            getStatusType(status) {
                // 将状态转换为字符串以确保正确匹配
                const statusStr = String(status);
                const typeMap = {
                    '0': 'info', 
                    '1': 'warning',
                    '2': 'success',
                    '3': 'info',
                    '4': 'danger'
                };
                return typeMap[statusStr] || '';
            },

            // 处理多选
            handleSelectionChange(selection) {
                this.multipleSelection = selection;
            },

            // 获取劳务列表
            async getServiceList() {
                this.loading = true;
                const params = {
                    pageNum: this.page,
                    pageSize: this.SizePage
                };
                
                try {
                    const res = await this.$get('/api/v1/works/servicelist', params);
                    if (res.data.code === 200) {
                        this.tableData = res.data.rows.map(item => ({
                            id: item.id,
                            lbCode: item.lbCode,
                            level: item.level,
                            name: item.name,
                            phone: item.phone,
                            bankCode: item.bankCode,
                            bankName: item.bankName,
                            signDate: item.signDate,
                            payDate: item.payDate,
                            payMoney: item.payMoney,
                            status: item.status
                        }));
                        this.total = res.data.total;
                    } else {
                        this.$message.error(res.data.msg || '获取列表失败');
                    }
                } catch (err) {
                    console.error('获取劳务列表失败:', err);
                    this.$message.error('获取列表失败');
                } finally {
                    this.loading = false;
                }
            },
            
            // 修改每页显示数量
            SizeChange(val) {
                this.SizePage = val;
                this.page = 1; // 重置到第一页
                this.getServiceList();
            },
            
            // 修改页码
            PageChange(val) {
                this.page = val;
                this.getServiceList();
            },

            // 处理查看详情按钮点击
            handleView(row) {
                // 获取基本信息
                this.$get(`/api/v1/works/service/${row.id}`).then(res => {
                    if (res.data.code === 200) {
                        const detail = res.data.data;
                        console.log("获取到的详情数据:", detail);
                        
                        // 直接从接口返回的完整数据中设置字段
                        this.editForm = {
                            id: detail.id,
                            lbCode: detail.lbCode,
                            name: detail.name,
                            phone: detail.phone,
                            bankCode: detail.bankCode,
                            bankName: detail.bankName,
                            signDate: detail.signDate,
                            payDate: detail.payDate,
                            payMoney: detail.payMoney,
                            status: detail.status,
                            // 将附件信息直接从接口返回数据中获取
                            serviceFile: detail.serviceFile || '',
                            cardNum: detail.cardNum || '',
                            cardFrontFile: detail.cardFrontFile || '',
                            cardBackFile: detail.cardBackFile || '',
                            zhichengFile: detail.zhichengFile || '',
                            bankFile: detail.bankFile || '',
                            zigeFile: detail.zigeFile || '' // 添加资格证书字段
                        };
                        
                        this.dialogVisible = true;
                        this.isViewMode = true; // 添加查看模式标记
                    } else {
                        this.$message.error(res.data.msg || '获取详情失败');
                    }
                }).catch(err => {
                    console.error('获取详情失败:', err);
                    this.$message.error('获取详情失败');
                });
            },

            // 查看文件
            viewFile(fileUrl) {
                if (!fileUrl) {
                    this.$message.warning('文件地址不存在');
                    return;
                }
                
                window.open(fileUrl, '_blank');
            },

            // 处理编辑按钮点击
            handleEdit(row) {
                // 获取基本信息
                this.$get(`/api/v1/works/service/${row.id}`).then(res => {
                    if (res.data.code === 200) {
                        const detail = res.data.data;
                        console.log("获取到的编辑数据:", detail);
                        
                        // 直接从接口返回的完整数据中设置字段
                        this.editForm = {
                            id: detail.id,
                            lbCode: detail.lbCode,
                            name: detail.name,
                            phone: detail.phone,
                            bankCode: detail.bankCode,
                            bankName: detail.bankName,
                            signDate: detail.signDate,
                            payDate: detail.payDate,
                            payMoney: detail.payMoney,
                            status: detail.status,
                            // 将附件信息直接从接口返回数据中获取
                            serviceFile: detail.serviceFile || '',
                            cardNum: detail.cardNum || '',
                            cardFrontFile: detail.cardFrontFile || '',
                            cardBackFile: detail.cardBackFile || '',
                            zhichengFile: detail.zhichengFile || '',
                            bankFile: detail.bankFile || '',
                            zigeFile: detail.zigeFile || '' // 添加资格证书字段
                        };
                        
                        this.dialogVisible = true;
                        this.isViewMode = false; // 编辑模式
                    } else {
                        this.$message.error(res.data.msg || '获取详情失败');
                    }
                }).catch(err => {
                    console.error('获取详情失败:', err);
                    this.$message.error('获取详情失败');
                });
            },

            // 处理保存按钮点击
            handleSave() {
                // TODO: 这里添加保存逻辑
                this.$message.success('保存成功');
                this.dialogVisible = false;
                this.getServiceList(); // 刷新列表
            },

            // 处理删除按钮点击
            handleDelete(row) {
                // TODO: 这里添加删除逻辑
                this.$message.success('删除成功');
                this.getServiceList(); // 刷新列表
            },

            // 处理签署按钮点击
            handleSign(row) {
                console.log('开始处理签署，行数据:', row);
                
                // 获取详细信息
                this.$get(`/api/v1/works/service/${row.id}`).then(res => {
                    if (res.data.code === 200) {
                        const detail = res.data.data;
                        console.log('获取到的服务详情:', detail);
                        
                        this.level = detail.level || 1; // 设置level
                        
                        // 特别处理作品名称和worksid
                        let worksName = '';
                        let worksid = '';
                        let worksType = '';
                        
                        // 如果是个人劳务(level=1)，尝试获取作品信息
                        if (this.level === 1) {
                            worksid = detail.worksId; // 使用 worksId 字段
                            console.log('作品ID:', worksid);
                            
                            // 如果有作品ID，则获取作品详情
                            if (worksid) {
                                this.$get(`/api/v1/works/workinfo/${worksid}`).then(workRes => {
                                    if (workRes.data.code === 200) {
                                        const workDetail = workRes.data.data;
                                        worksType = workDetail.worksType;
                                        worksName = workDetail.worksName;
                                        
                                        // 更新表单数据
                                        this.signForm.worksType = worksType;
                                        this.signForm.worksName = worksName;
                                        
                                        // 首先尝试加载用户之前填过的劳务信息
                                        this.tryLoadPreviousLabor().then(prevData => {
                                            // 先获取银行卡和身份证等信息
                                            this.$get(`/api/v1/works/getLaborUserInfo?id=${row.id}`).then(infoRes => {
                                                if (infoRes.data.code === 200) {
                                                    const laborInfo = infoRes.data.data;
                                                    console.log('获取到的劳务信息:', laborInfo);
                                                    
                                                    // 设置表单所有字段值，优先使用作品信息中的单位和职称，其次是历史数据
                                                    this.signForm = {
                                                        id: detail.id,
                                                        name: prevData ? prevData.name : (detail.name || ''),
                                                        phone: prevData ? prevData.phone : (detail.phone || ''),
                                                        cardNum: prevData ? prevData.cardNum : (laborInfo.cardNum || ''),
                                                        bankCode: prevData ? prevData.bankCode : (detail.bankCode || ''),
                                                        bankName: prevData ? prevData.bankName : (detail.bankName || ''),
                                                        // 优先使用作品信息中的单位和职称
                                                        workUnit: workDetail.userUnit || (prevData ? prevData.workUnit : ''),
                                                        title: workDetail.userZhicheng || (prevData ? prevData.title : ''),
                                                        payMoney: detail.payMoney || '', // 金额始终使用当前劳务的值
                                                        signDate: this.getCurrentDate(), // 默认设置为当前日期
                                                        signature: '',
                                                        lbCode: detail.lbCode || '',
                                                        projectId: detail.projectId || '',
                                                        worksid: worksid,
                                                        worksType: worksType,
                                                        worksName: worksName || '（未提供作品名称）',
                                                        agreeId: detail.agreeId || '',
                                                        // 如果之前有上传过证件照片，也要复用
                                                        cardFrontFile: prevData ? prevData.cardFrontFile : '',
                                                        cardBackFile: prevData ? prevData.cardBackFile : '',
                                                        bankFile: prevData ? prevData.bankFile : '',
                                                        zhichengFile: prevData ? prevData.zhichengFile : '',
                                                        zigeFile: prevData ? prevData.zigeFile : '',
                                                        // 图片预览URL
                                                        cardFrontPreviewUrl: prevData && prevData.cardFrontFile ? prevData.cardFrontFile : '',
                                                        cardBackPreviewUrl: prevData && prevData.cardBackFile ? prevData.cardBackFile : '',
                                                        bankPreviewUrl: prevData && prevData.bankFile ? prevData.bankFile : '',
                                                        zhichengPreviewUrl: prevData && prevData.zhichengFile ? prevData.zhichengFile : '',
                                                        zigePreviewUrl: prevData && prevData.zigeFile ? prevData.zigeFile : ''
                                                    };
                                                    
                                                    
                                                    // 显示弹窗
                                                    this.signDialogVisible = true;
                                                    this.signStep = 1;
                                                    this.setCurrentDate(); // 设置当前日期
                                                    
                                                    // 清除之前的签名
                                                    this.signatureImage = '';
                                                }
                                            }).catch(err => {
                                                console.error('获取劳务详细信息失败:', err);
                                                this.$message.error('获取详细信息失败');
                                            });
                                        });
                                    }
                                }).catch(err => {
                                    console.error('获取作品详情失败:', err);
                                    // 如果获取作品详情失败，仍然需要继续流程
                                    this.continueWithoutWorkInfo(detail, row, worksid, worksType, worksName);
                                });
                            } else {
                                // 没有作品ID时继续流程
                                this.continueWithoutWorkInfo(detail, row, worksid, worksType, worksName);
                            }
                        } 
                        // 如果是专家劳务(level=3)，直接进入签署流程
                        else if (this.level === 3) {
                            console.log('专家劳务签署流程');
                            
                            // 获取专家的工作单位和医务职称
                            this.tryLoadPreviousLabor().then(prevData => {
                                // 获取银行卡和身份证等信息
                                this.$get(`/api/v1/works/getLaborUserInfo?id=${row.id}`).then(infoRes => {
                                    if (infoRes.data.code === 200) {
                                        const laborInfo = infoRes.data.data;
                                        console.log('获取到的专家劳务信息:', laborInfo);
                                        
                                        // 尝试获取专家信息中的工作单位和职称
                                        let userUnit = '';
                                        let userZhicheng = '';
                                        
                                        // 如果有worksId，尝试从作品信息获取单位和职称
                                        if (detail.worksId) {
                                            console.log('尝试从作品信息获取单位和职称，worksId:', detail.worksId);
                                            this.$get(`/api/v1/works/workinfo/${detail.worksId}`).then(workRes => {
                                                if (workRes.data.code === 200) {
                                                    const workDetail = workRes.data.data;
                                                    userUnit = workDetail.userUnit || '';
                                                    userZhicheng = workDetail.userZhicheng || '';
                                                    console.log('获取到的作品信息中的单位和职称:', userUnit, userZhicheng);
                                                    
                                                    this.setupExpertForm(detail, row, prevData, laborInfo, userUnit, userZhicheng);
                                                } else {
                                                    console.warn('获取作品信息失败，使用默认值');
                                                    this.setupExpertForm(detail, row, prevData, laborInfo, userUnit, userZhicheng);
                                                }
                                            }).catch(err => {
                                                console.error('获取作品信息失败:', err);
                                                this.setupExpertForm(detail, row, prevData, laborInfo, userUnit, userZhicheng);
                                            });
                                        } else {
                                            // 没有作品ID时，直接设置表单
                                            this.setupExpertForm(detail, row, prevData, laborInfo, userUnit, userZhicheng);
                                        }
                                    } else {
                                        this.$message.error(infoRes.data.msg || '获取劳务信息失败');
                                    }
                                }).catch(err => {
                                    console.error('获取专家劳务详细信息失败:', err);
                                    this.$message.error('获取详细信息失败');
                                });
                            });
                        }
                        // 处理其他类型的劳务
                        else {
                            this.continueWithoutWorkInfo(detail, row, worksid, worksType, worksName);
                        }
                    } else {
                        this.$message.error(res.data.msg || '获取详情失败');
                    }
                }).catch(err => {
                    console.error('获取详情失败:', err);
                    this.$message.error('获取详情失败');
                });
            },

            // 没有作品信息时继续签署流程
            continueWithoutWorkInfo(detail, row, worksid, worksType, worksName) {
                // 首先尝试加载用户之前填过的劳务信息
                this.tryLoadPreviousLabor().then(prevData => {
                    // 先获取银行卡和身份证等信息
                    this.$get(`/api/v1/works/getLaborUserInfo?id=${row.id}`).then(infoRes => {
                        if (infoRes.data.code === 200) {
                            const laborInfo = infoRes.data.data;
                            console.log('获取到的劳务信息:', laborInfo);
                            
                            // 设置表单所有字段值，优先使用之前保存的数据
                            this.signForm = {
                                id: detail.id,
                                name: prevData ? prevData.name : (detail.name || ''),
                                phone: prevData ? prevData.phone : (detail.phone || ''),
                                cardNum: prevData ? prevData.cardNum : (laborInfo.cardNum || ''),
                                bankCode: prevData ? prevData.bankCode : (detail.bankCode || ''),
                                bankName: prevData ? prevData.bankName : (detail.bankName || ''),
                                workUnit: prevData ? prevData.workUnit : (detail.workUnit || ''),
                                title: prevData ? prevData.title : (detail.title || ''),
                                payMoney: detail.payMoney || '', // 金额始终使用当前劳务的值
                                signDate: this.getCurrentDate(), // 默认设置为当前日期
                                signature: '',
                                lbCode: detail.lbCode || '',
                                projectId: detail.projectId || '',
                                worksid: worksid,
                                worksType: worksType,
                                worksName: worksName || '（未提供作品名称）',
                                agreeId: detail.agreeId || '',
                                // 如果之前有上传过证件照片，也要复用
                                cardFrontFile: prevData ? prevData.cardFrontFile : '',
                                cardBackFile: prevData ? prevData.cardBackFile : '',
                                bankFile: prevData ? prevData.bankFile : '',
                                zhichengFile: prevData ? prevData.zhichengFile : '',
                                zigeFile: prevData ? prevData.zigeFile : '',
                                // 图片预览URL
                                cardFrontPreviewUrl: prevData && prevData.cardFrontFile ? prevData.cardFrontFile : '',
                                cardBackPreviewUrl: prevData && prevData.cardBackFile ? prevData.cardBackFile : '',
                                bankPreviewUrl: prevData && prevData.bankFile ? prevData.bankFile : '',
                                zhichengPreviewUrl: prevData && prevData.zhichengFile ? prevData.zhichengFile : '',
                                zigePreviewUrl: prevData && prevData.zigeFile ? prevData.zigeFile : ''
                            };
                            
                            console.log('签署表单初始数据:', this.signForm);
                            
                            // 显示弹窗
                            this.signDialogVisible = true;
                            this.signStep = 1;
                            this.setCurrentDate(); // 设置当前日期
                            
                            // 清除之前的签名
                            this.signatureImage = '';
                        }
                    }).catch(err => {
                        console.error('获取劳务详细信息失败:', err);
                        this.$message.error('获取详细信息失败');
                    });
                });
            },

            // 新增方法：尝试加载用户之前签署过的劳务信息
            tryLoadPreviousLabor() {
                return new Promise((resolve) => {
                    // 获取用户最近签署过的劳务信息
                    this.$get('/api/v1/works/servicelist', {
                        pageNum: 1,
                        pageSize: 100
                    }).then(res => {
                        if (res.data.code === 200 && res.data.rows && res.data.rows.length > 0) {
                            // 筛选已签署的劳务（状态为1或2的）
                            const signedLabors = res.data.rows.filter(item => 
                                (item.status === 1 || item.status === 2 || item.status === '1' || item.status === '2')
                            );
                            
                            if (signedLabors.length > 0) {
                                // 获取最后一次已签署劳务的详细信息
                                const latestLabor = signedLabors[signedLabors.length - 1]; // 获取最后一条数据
                                
                                this.$get(`/api/v1/works/service/${latestLabor.id}`).then(detailRes => {
                                    if (detailRes.data.code === 200) {
                                        const detail = detailRes.data.data;
                                        console.log('获取到的上一次劳务信息:', detail);
                                        
                                        // 返回之前的劳务信息
                                        resolve({
                                            name: detail.name || '',
                                            phone: detail.phone || '',
                                            cardNum: detail.cardNum || '',
                                            bankCode: detail.bankCode || '',
                                            bankName: detail.bankName || '',
                                            workUnit: detail.workUnit || '',
                                            title: detail.title || '',
                                            cardFrontFile: detail.cardFrontFile || '',
                                            cardBackFile: detail.cardBackFile || '',
                                            bankFile: detail.bankFile || '',
                                            zhichengFile: detail.zhichengFile || '',
                                            zigeFile: detail.zigeFile || ''
                                        });
                                    } else {
                                        console.log('获取历史劳务详情失败:', detailRes.data.msg);
                                        resolve(null);
                                    }
                                }).catch(err => {
                                    console.error('获取历史劳务详情失败:', err);
                                    resolve(null);
                                });
                            } else {
                                console.log('没有找到已签署的劳务');
                                resolve(null);
                            }
                        } else {
                            console.log('获取劳务列表失败或列表为空');
                            resolve(null);
                        }
                    }).catch(err => {
                        console.error('获取劳务列表失败:', err);
                        resolve(null);
                    });
                });
            },

            // 获取当前日期
            getCurrentDate() {
                const now = new Date();
                const year = now.getFullYear();
                const month = String(now.getMonth() + 1).padStart(2, '0');
                const day = String(now.getDate()).padStart(2, '0');
                return `${year}-${month}-${day}`;
            },
            
            // 切换到下一步
            nextStep() {
                // 验证表单
                this.$refs.signForm.validate(valid => {
                    if (!valid) {
                        this.$message.error('请完善必填信息');
                        return;
                    }
                    
                    // 切换到授权书签署步骤
                    this.signStep = 2;
                    
                    // 设置当前日期
                    this.currentDate = this.getCurrentDate();
                    
                    // 在DOM更新后，确保授权书元素可以被正确访问
                    this.$nextTick(() => {
                        if (!this.$refs.authorizationContainer) {
                            console.warn('授权书容器元素在DOM更新后仍未找到');
                        } else {
                            console.log('授权书容器元素已找到:', this.$refs.authorizationContainer);
                        }
                    });
                });
            },

            // 设置当前日期
            setCurrentDate() {
                const today = new Date();
                const year = today.getFullYear();
                const month = String(today.getMonth() + 1).padStart(2, '0');
                const day = String(today.getDate()).padStart(2, '0');
                this.currentDate = `${year}-${month}-${day}`;
            },

            // 处理签名点击事件
            handleSignClick() {
                this.openSignaturePad();
            },
            
            // 打开签名弹窗
            openSignaturePad() {
                this.showSignaturePad = true;
                this.$nextTick(() => {
                    // 初始化原生canvas实现的签名板
                    this.initNativeCanvas();
                });
            },
            
            // 初始化原生Canvas实现的签名板
            initNativeCanvas() {
                const canvas = this.$refs.signaturePad;
                if (!canvas) return;
                
                // 获取2D上下文
                const ctx = canvas.getContext('2d');
                
                // 设置画布尺寸 - 使用设备像素比修正高分辨率屏幕
                const dpr = window.devicePixelRatio || 1;
                const rect = canvas.getBoundingClientRect();
                
                // 设置画布的物理尺寸与其在页面中的实际尺寸一致
                canvas.width = rect.width * dpr;
                canvas.height = rect.height * dpr;
                canvas.style.width = `${rect.width}px`;
                canvas.style.height = `${rect.height}px`;
                
                // 根据设备像素比缩放上下文
                ctx.scale(dpr, dpr);
                
                // 设置画布背景为白色
                ctx.fillStyle = 'white';
                ctx.fillRect(0, 0, canvas.width, canvas.height);
                
                // 设置线条样式
                ctx.strokeStyle = 'black';
                ctx.lineWidth = 2;
                ctx.lineCap = 'round';
                ctx.lineJoin = 'round';
                
                // 绘图状态
                let isDrawing = false;
                let lastX = 0;
                let lastY = 0;
                
                // 获取鼠标相对于画布的坐标
                const getMousePos = (e) => {
                    const rect = canvas.getBoundingClientRect();
                    // 根据设备像素比进行修正
                    return {
                        x: (e.clientX - rect.left) / (rect.width / canvas.width * dpr),
                        y: (e.clientY - rect.top) / (rect.height / canvas.height * dpr)
                    };
                };
                
                // 触摸点坐标
                const getTouchPos = (e) => {
                    const rect = canvas.getBoundingClientRect();
                    const touch = e.touches[0];
                    // 根据设备像素比进行修正
                    return {
                        x: (touch.clientX - rect.left) / (rect.width / canvas.width * dpr),
                        y: (touch.clientY - rect.top) / (rect.height / canvas.height * dpr)
                    };
                };
                
                // 开始绘制
                const startDrawing = (e) => {
                    const pos = getMousePos(e);
                    isDrawing = true;
                    
                    // 记录起始点
                    lastX = pos.x;
                    lastY = pos.y;
                    
                    // 绘制起始点（小圆点）
                    ctx.beginPath();
                    ctx.arc(lastX, lastY, 1, 0, Math.PI * 2);
                    ctx.fill();
                };
                
                // 绘制线条
                const draw = (e) => {
                    if (!isDrawing) return;
                    
                    const pos = getMousePos(e);
                    
                    // 绘制线条
                    ctx.beginPath();
                    ctx.moveTo(lastX, lastY);
                    ctx.lineTo(pos.x, pos.y);
                    ctx.stroke();
                    
                    // 更新位置
                    lastX = pos.x;
                    lastY = pos.y;
                };
                
                // 结束绘制
                const endDrawing = () => {
                    isDrawing = false;
                };
                
                // 触摸开始
                const handleTouchStart = (e) => {
                    e.preventDefault();
                    const pos = getTouchPos(e);
                    isDrawing = true;
                    
                    // 记录起始点
                    lastX = pos.x;
                    lastY = pos.y;
                    
                    // 绘制起始点
                    ctx.beginPath();
                    ctx.arc(lastX, lastY, 1, 0, Math.PI * 2);
                    ctx.fill();
                };
                
                // 触摸移动
                const handleTouchMove = (e) => {
                    e.preventDefault();
                    if (!isDrawing) return;
                    
                    const pos = getTouchPos(e);
                    
                    // 绘制线条
                    ctx.beginPath();
                    ctx.moveTo(lastX, lastY);
                    ctx.lineTo(pos.x, pos.y);
                    ctx.stroke();
                    
                    // 更新位置
                    lastX = pos.x;
                    lastY = pos.y;
                };
                
                // 触摸结束
                const handleTouchEnd = (e) => {
                    e.preventDefault();
                    isDrawing = false;
                };
                
                // 清除画布
                this.clearSignatureCanvas = () => {
                    ctx.fillStyle = 'white';
                    ctx.fillRect(0, 0, canvas.width, canvas.height);
                    
                    // 重置线条样式
                    ctx.strokeStyle = 'black';
                    ctx.lineWidth = 2;
                    ctx.lineCap = 'round';
                    ctx.lineJoin = 'round';
                };
                
                // 检查画布是否为空（全白）
                this.isCanvasEmpty = () => {
                    const pixelData = ctx.getImageData(0, 0, canvas.width, canvas.height).data;
                    
                    // 检查是否所有像素都是白色
                    for (let i = 0; i < pixelData.length; i += 4) {
                        // 非白色像素
                        if (pixelData[i] !== 255 || 
                            pixelData[i+1] !== 255 || 
                            pixelData[i+2] !== 255 || 
                            pixelData[i+3] !== 255) {
                            return false;
                        }
                    }
                    
                    return true;
                };
                
                // 获取画布图像
                this.getCanvasImage = () => {
                    return canvas.toDataURL('image/png');
                };
                
                // 添加事件监听器
                canvas.addEventListener('mousedown', startDrawing);
                canvas.addEventListener('mousemove', draw);
                canvas.addEventListener('mouseup', endDrawing);
                canvas.addEventListener('mouseout', endDrawing);
                
                // 添加触摸事件监听器
                canvas.addEventListener('touchstart', handleTouchStart, { passive: false });
                canvas.addEventListener('touchmove', handleTouchMove, { passive: false });
                canvas.addEventListener('touchend', handleTouchEnd, { passive: false });
                
                // 阻止默认触摸行为
                canvas.style.touchAction = 'none';
                
                // 保存事件解绑函数
                this.cleanupCanvas = () => {
                    canvas.removeEventListener('mousedown', startDrawing);
                    canvas.removeEventListener('mousemove', draw);
                    canvas.removeEventListener('mouseup', endDrawing);
                    canvas.removeEventListener('mouseout', endDrawing);
                    canvas.removeEventListener('touchstart', handleTouchStart);
                    canvas.removeEventListener('touchmove', handleTouchMove);
                    canvas.removeEventListener('touchend', handleTouchEnd);
                };
            },
            
            // 清除签名
            clearSignature() {
                if (this.clearSignatureCanvas) {
                    this.clearSignatureCanvas();
                }
            },
            
            // 将base64转换为Blob
            base64ToBlob(base64, mimeType = 'image/png') {
                // 移除data URL前缀
                const base64Data = base64.split(',')[1];
                // 转换为字节数组
                const byteCharacters = atob(base64Data);
                const byteNumbers = new Array(byteCharacters.length);
                for (let i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                }
                const byteArray = new Uint8Array(byteNumbers);
                return new Blob([byteArray], { type: mimeType });
            },
            
            // 保存签名
            async saveSignature() {
                if (!this.getCanvasImage || this.isCanvasEmpty()) {
                    this.$message.error('请先签名');
                    return;
                }
                
                // 获取签名图片的base64
                const base64Image = this.getCanvasImage();
                
                // 显示上传中提示
                const loading = this.$loading({
                    lock: true,
                    text: '正在上传签名...',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                
                try {
                    // 将base64转换为Blob
                    const blob = this.base64ToBlob(base64Image, 'image/png');
                    
                    // 创建File对象
                    const file = new File([blob], 'signature.png', { type: 'image/png' });
                    
                    // 创建FormData
                    const formData = new FormData();
                    formData.append('file', file);
                    
                    // 上传到服务器
                    const axios = this.$axios || require('axios').default;
                    const response = await axios.post('/common/upload', formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    });
                    
                    loading.close();
                    
                    if (response.data.code === 200) {
                        // 保存服务器返回的URL
                        const signatureUrl = response.data.url;
                        this.signatureImage = signatureUrl;
                        this.signForm.signature = signatureUrl;
                        
                        // 关闭签名弹窗
                        this.closeSignaturePad();
                        
                        // 显示成功提示
                        this.$message.success('签名上传成功');
                        
                        // 强制更新视图
                        this.$forceUpdate();
                    } else {
                        this.$message.error(response.data.msg || '签名上传失败');
                    }
                } catch (error) {
                    loading.close();
                    console.error('签名上传失败:', error);
                    this.$message.error('签名上传失败，请重试');
                }
            },
            
            // 关闭签名弹窗
            closeSignaturePad() {
                this.showSignaturePad = false;
                
                // 清理事件监听器
                if (this.cleanupCanvas) {
                    this.cleanupCanvas();
                }
            },

            // 获取劳务类型文本
            getLevelText(level) {
                const levelMap = {
                    '1': '个人劳务',
                    '2': '初审劳务',
                    '3': '专家劳务'
                };
                return levelMap[level] || level;
            },

            // 文件上传前的验证
            beforeUpload(file) {
                const isJPGOrPNG = file.type === 'image/jpeg' || file.type === 'image/png';
                const isLt500K = file.size / 1024 < 50000;

                if (!isJPGOrPNG) {
                    this.$message.error('上传文件只能是 JPG/PNG 格式!');
                    return false;
                }
                if (!isLt500K) {
                    this.$message.error('上传文件大小不能超过 500KB!');
                    return false;
                }
                return true;
            },
            
            // 触发文件选择
            triggerUpload(inputRef) {
                this.$refs[inputRef].click();
            },
            
            // 上传文件方法
            async uploadFile(file, successCallback) {
                // 验证文件
                if (!this.beforeUpload(file)) {
                    return;
                }
                
                // 显示上传中
                const loading = this.$loading({
                    lock: true,
                    text: '上传中...',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                
                try {
                    // 创建表单数据
                    const formData = new FormData();
                    formData.append('file', file);
                    
                    // 上传文件
                    const response = await axios.post('/common/upload', formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    });
                    
                    loading.close();
                    
                    // 处理响应
                    if (response.data.code === 200) {
                        this.$message.success('文件上传成功');
                        successCallback(response.data);
                    } else {
                        this.$message.error(response.data.msg || '上传失败');
                    }
                } catch (error) {
                    loading.close();
                    console.error('文件上传失败:', error);
                    this.$message.error('文件上传失败，请重试');
                }
            },
            
            // 上传身份证正面照片
            uploadCardFront(e) {
                const file = e.target.files[0];
                if (!file) return;
                
                if (!this.beforeUpload(file)) {
                    this.$refs.cardFrontInput.value = '';
                    return;
                }

                const formData = new FormData();
                formData.append('file', file);

                // 先创建本地预览URL
                this.signForm.cardFrontPreviewUrl = URL.createObjectURL(file);

                axios.post('/common/upload', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }).then(res => {
                    if (res.data.code === 200) {
                        this.$message.success('上传成功');
                        this.signForm.cardFrontFile = res.data.url;
                        this.signForm.cardFrontFileName = file.name;
                        this.$refs.cardFrontInput.value = '';
                        // 强制更新视图
                        this.$forceUpdate();
                    } else {
                        this.$message.error(res.data.msg || '上传失败');
                        // 上传失败时清除预览
                        this.signForm.cardFrontPreviewUrl = '';
                    }
                }).catch(err => {
                    console.error('上传失败:', err);
                    this.$message.error('上传失败');
                    // 上传失败时清除预览
                    this.signForm.cardFrontPreviewUrl = '';
                });
            },
            
            // 上传身份证反面照片
            uploadCardBack(e) {
                const file = e.target.files[0];
                if (!file) return;
                
                if (!this.beforeUpload(file)) {
                    this.$refs.cardBackInput.value = '';
                    return;
                }

                const formData = new FormData();
                formData.append('file', file);

                // 先创建本地预览URL
                this.signForm.cardBackPreviewUrl = URL.createObjectURL(file);

                axios.post('/common/upload', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }).then(res => {
                    if (res.data.code === 200) {
                        this.$message.success('上传成功');
                        this.signForm.cardBackFile = res.data.url;
                        this.signForm.cardBackFileName = file.name;
                        this.$refs.cardBackInput.value = '';
                        // 强制更新视图
                        this.$forceUpdate();
                    } else {
                        this.$message.error(res.data.msg || '上传失败');
                        // 上传失败时清除预览
                        this.signForm.cardBackPreviewUrl = '';
                    }
                }).catch(err => {
                    console.error('上传失败:', err);
                    this.$message.error('上传失败');
                    // 上传失败时清除预览
                    this.signForm.cardBackPreviewUrl = '';
                });
            },
            
            // 上传银行卡照片
            uploadBankFile(e) {
                const file = e.target.files[0];
                if (!file) return;
                
                if (!this.beforeUpload(file)) {
                    this.$refs.bankFileInput.value = '';
                    return;
                }

                const formData = new FormData();
                formData.append('file', file);

                // 先创建本地预览URL
                this.signForm.bankPreviewUrl = URL.createObjectURL(file);

                axios.post('/common/upload', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }).then(res => {
                    if (res.data.code === 200) {
                        this.$message.success('上传成功');
                        this.signForm.bankFile = res.data.url;
                        this.signForm.bankFileName = file.name;
                        this.$refs.bankFileInput.value = '';
                        // 强制更新视图
                        this.$forceUpdate();
                    } else {
                        this.$message.error(res.data.msg || '上传失败');
                        // 上传失败时清除预览
                        this.signForm.bankPreviewUrl = '';
                    }
                }).catch(err => {
                    console.error('上传失败:', err);
                    this.$message.error('上传失败');
                    // 上传失败时清除预览
                    this.signForm.bankPreviewUrl = '';
                });
            },
            
            // 上传职称证明
            uploadZhichengFile(e) {
                const file = e.target.files[0];
                if (!file) return;
                
                if (!this.beforeUpload(file)) {
                    this.$refs.zhichengFileInput.value = '';
                    return;
                }

                const formData = new FormData();
                formData.append('file', file);

                // 先创建本地预览URL
                this.signForm.zhichengPreviewUrl = URL.createObjectURL(file);

                axios.post('/common/upload', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }).then(res => {
                    if (res.data.code === 200) {
                        this.$message.success('上传成功');
                        this.signForm.zhichengFile = res.data.url;
                        this.signForm.zhichengFileName = file.name;
                        this.$refs.zhichengFileInput.value = '';
                        // 强制更新视图
                        this.$forceUpdate();
                        
                        // 触发表单验证
                        this.$nextTick(() => {
                            this.$refs.signForm.validateField('zhichengFile');
                        });
                    } else {
                        this.$message.error(res.data.msg || '上传失败');
                        // 上传失败时清除预览
                        this.signForm.zhichengPreviewUrl = '';
                    }
                }).catch(err => {
                    console.error('上传失败:', err);
                    this.$message.error('上传失败');
                    // 上传失败时清除预览
                    this.signForm.zhichengPreviewUrl = '';
                });
            },
            
            // 上传资格证书
            uploadZigeFile(e) {
                const file = e.target.files[0];
                if (!file) return;
                
                if (!this.beforeUpload(file)) {
                    this.$refs.zigeFileInput.value = '';
                    return;
                }

                const formData = new FormData();
                formData.append('file', file);

                // 先创建本地预览URL
                this.signForm.zigePreviewUrl = URL.createObjectURL(file);

                axios.post('/common/upload', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }).then(res => {
                    if (res.data.code === 200) {
                        this.$message.success('上传成功');
                        this.signForm.zigeFile = res.data.url;
                        this.signForm.zigeFileName = file.name;
                        this.$refs.zigeFileInput.value = '';
                        // 强制更新视图
                        this.$forceUpdate();
                    } else {
                        this.$message.error(res.data.msg || '上传失败');
                        // 上传失败时清除预览
                        this.signForm.zigePreviewUrl = '';
                    }
                }).catch(err => {
                    console.error('上传失败:', err);
                    this.$message.error('上传失败');
                    // 上传失败时清除预览
                    this.signForm.zigePreviewUrl = '';
                });
            },
            
            // 提交签名表单
            submitSign() {
                if (!this.signatureImage) {
                    this.$message.error('请完成签名');
                    return false;
                }
                
                try {
                    console.log('开始提交签名，当前表单数据:', this.signForm);
                    
                    // 显示加载中
                    const loading = this.$loading({
                        lock: true,
                        text: '提交中...',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    
                    // 构建提交数据
                    // signature字段现在传递的是服务器URL路径，而不是base64字符串
                    const submitData = {
                        id: this.signForm.id,
                        name: this.signForm.name,
                        phone: this.signForm.phone,
                        cardNum: this.signForm.cardNum,
                        bankCode: this.signForm.bankCode,
                        bankName: this.signForm.bankName,
                        bankProvince: this.signForm.bankProvince || '',
                        bankCity: this.signForm.bankCity || '',
                        zhichengFile: this.signForm.zhichengFile,
                        zigeFile: this.signForm.zhigeFile,
                        cardBackFile: this.signForm.cardBackFile,
                        bankFile: this.signForm.bankFile,
                        cardFrontFile: this.signForm.cardFrontFile,
                        payMoney: this.signForm.payMoney,
                        signDate: this.signForm.signDate,
                        signature: this.signatureImage,
                        agreeId: this.signForm.agreeId || '',
                        level: this.level || 1,
                        status: 1,
                        lbCode: this.signForm.lbCode || '',
                        worksId: this.signForm.worksid || '',
                        workUnit: this.signForm.workUnit || '',
                        title: this.signForm.title || '',
                        department: this.signForm.department || ''
                    };
                    
                    // 当level为1时，添加作品名称字段
                    if (this.level === 1) {
                        submitData.worksType = this.signForm.worksType || ''; // 添加作品类型字段
                        submitData.worksTypeText = this.getWorksTypeText(this.signForm.worksType) || ''; // 添加转换后的作品类型文本
                    }
                    
                    console.log('提交的完整数据:', submitData);
                    
                    // 使用axios或this.$http执行POST请求
                    const http = this.$http || axios;
                    
                    http.post('/api/v1/works/addservice', submitData).then(res => {
                        loading.close();
                        
                        if (res.data.code === 200) {
                            this.$message.success('签约成功');
                            // 关闭弹窗
                            this.signDialogVisible = false;
                            // 刷新列表
                            this.getServiceList();
                            // 延迟跳转
                            setTimeout(() => {
                                this.$router.push('/UserInfo');
                            }, 1500);
                        } else {
                            this.$message.error(res.data.msg || '提交失败');
                        }
                    }).catch(error => {
                        loading.close();
                        console.error('提交出错:', error);
                        this.$message.error('提交失败，请重试');
                    });
                } catch (error) {
                    console.error('提交出错:', error);
                    this.$message.error('操作失败，请重试');
                }
            },

            // 生成授权书PDF并上传
            async generateAndUploadPDF() {
                try {
                    // 获取授权书容器元素
                    const element = this.$refs.authorizationContainer;
                    if (!element) {
                        console.error('找不到授权书容器元素，ref:', this.$refs);
                        throw new Error('找不到授权书容器元素');
                    }
                    
                    console.log('授权书容器元素:', element);
                    
                    // 检测是否为移动设备
                    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
                    
                    // 调整移动端样式以保持与PC端相同大小
                    if (isMobile) {
                        // 保存原始样式
                        const originalStyles = {
                            width: element.style.width,
                            height: element.style.height,
                            overflow: element.style.overflow,
                            position: element.style.position,
                            backgroundColor: element.style.backgroundColor,
                            transform: element.style.transform,
                            transformOrigin: element.style.transformOrigin
                        };
                        
                        // 设置临时样式以确保完整捕获，并保持与PC端一致的尺寸
                        element.style.width = '900px';
                        element.style.height = 'auto';
                        element.style.overflow = 'visible';
                        element.style.position = 'relative';
                        element.style.backgroundColor = '#ffffff'; // 确保背景为白色
                        element.style.transform = 'scale(1)';
                        element.style.transformOrigin = 'top left';
                        
                        // 等待DOM更新
                        await this.$nextTick();
                    }
                    
                    // 等待所有图片加载完成
                    await this.waitForImages(element);
                    
                    // 捕获授权书HTML为canvas
                    const canvas = await html2canvas(element, {
                        scale: 2, // 固定使用较高的分辨率，无论是PC还是移动端
                        useCORS: true, // 允许跨域图像
                        logging: true, // 开启日志便于调试
                        allowTaint: true, // 允许跨域图片
                        backgroundColor: '#ffffff', // 设置背景色为白色
                        foreignObjectRendering: false, // 禁用foreignObject渲染，可能导致黑屏
                        scrollY: 0, // 防止滚动影响
                        windowWidth: 900, // 固定窗口宽度
                        windowHeight: element.scrollHeight, // 设置窗口高度
                        onclone: (clonedDoc) => {
                            // 处理克隆的DOM，确保所有内容可见
                            const clonedElement = clonedDoc.querySelector('.authorization-form');
                            if (clonedElement) {
                                clonedElement.style.width = '900px';
                                clonedElement.style.height = 'auto';
                                clonedElement.style.overflow = 'visible';
                                clonedElement.style.backgroundColor = '#ffffff'; // 确保背景为白色
                            }
                            
                            // 确保所有文本元素可见
                            const textElements = clonedDoc.querySelectorAll('p, h1, h2, h3, h4, h5, h6, span, div');
                            textElements.forEach(el => {
                                if (el.style) {
                                    el.style.color = '#000000'; // 确保文本为黑色
                                }
                            });
                        }
                    });
                    
                    // 如果是移动设备，恢复原始样式
                    if (isMobile) {
                        const originalStyles = {
                            width: element.style.width,
                            height: element.style.height,
                            overflow: element.style.overflow,
                            position: element.style.position,
                            backgroundColor: element.style.backgroundColor,
                            transform: element.style.transform,
                            transformOrigin: element.style.transformOrigin
                        };
                        
                        // 恢复原始样式
                        element.style.width = originalStyles.width;
                        element.style.height = originalStyles.height;
                        element.style.overflow = originalStyles.overflow;
                        element.style.position = originalStyles.position;
                        element.style.backgroundColor = originalStyles.backgroundColor;
                        element.style.transform = originalStyles.transform;
                        element.style.transformOrigin = originalStyles.transformOrigin;
                    }
                    
                    // 创建PDF文档
                    const pdf = new jsPDF('p', 'mm', 'a4');
                    const imgData = canvas.toDataURL('image/jpeg', 1.0);
                    
                    // 计算PDF尺寸
                    const imgWidth = 210; // A4宽度(mm)
                    const pageHeight = 297; // A4高度(mm)
                    const imgHeight = canvas.height * imgWidth / canvas.width;
                    
                    // 如果内容超过一页，分页处理
                    let heightLeft = imgHeight;
                    let position = 0;
                    
                    // 添加第一页
                    pdf.addImage(imgData, 'JPEG', 0, position, imgWidth, imgHeight);
                    heightLeft -= pageHeight;
                    
                    // 如果内容超过一页，继续添加新页
                    while (heightLeft > 0) {
                        position = heightLeft - imgHeight;
                        pdf.addPage();
                        pdf.addImage(imgData, 'JPEG', 0, position, imgWidth, imgHeight);
                        heightLeft -= pageHeight;
                    }
                    
                    // 生成PDF blob
                    const pdfBlob = pdf.output('blob');
                    
                    // 创建上传表单
                    const formData = new FormData();
                    const file = new File([pdfBlob], '劳务协议授权书.pdf', { type: 'application/pdf' });
                    formData.append('file', file);
                    
                    // 上传PDF文件
                    const axios = this.$axios || require('axios').default;
                    
                    const response = await axios.post('/common/upload', formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    });
                    
                    if (response.data.code === 200) {
                        this.$message.success('授权书生成成功');
                        return response.data.url;
                    } else {
                        throw new Error(response.data.msg || '授权书生成失败');
                    }
                } catch (error) {
                    console.error('生成或上传PDF时出错:', error);
                    this.$message.error(`授权书生成失败: ${error.message}`);
                    return null;
                }
            },

            // 添加等待图片加载的方法
            async waitForImages(element) {
                const images = element.getElementsByTagName('img');
                const imagePromises = Array.from(images).map(img => {
                    if (img.complete) {
                        return Promise.resolve();
                    }
                    return new Promise((resolve, reject) => {
                        img.onload = resolve;
                        img.onerror = reject;
                    });
                });
                
                try {
                    await Promise.all(imagePromises);
                } catch (error) {
                    console.warn('部分图片加载失败:', error);
                }
            },

            // 获取作品类型文本
            getWorksTypeText(types) {
                const typeMap = {
                    '1': '科普文章',
                    '2': '科普图画',
                    '3': '科普短视频',
                    '4': '科普讲座'
                };
                
                if (!types) return '';
                
                // 如果types是单个数字，直接返回对应的文本
                if (typeMap[types]) {
                    return typeMap[types];
                }
                
                // 如果是逗号分隔的多个类型，则转换每个类型
                const typeArray = types.split(',');
                return typeArray.map(type => typeMap[type.trim()] || type).join('，');
            },

            // 设置专家劳务表单
            setupExpertForm(detail, row, prevData, laborInfo, userUnit, userZhicheng) {
                // 设置表单字段值，优先使用作品信息中的单位和职称，其次是历史数据
                this.signForm = {
                    id: detail.id,
                    name: prevData ? prevData.name : (detail.name || ''),
                    phone: prevData ? prevData.phone : (detail.phone || ''),
                    cardNum: prevData ? prevData.cardNum : (laborInfo.cardNum || ''),
                    bankCode: prevData ? prevData.bankCode : (detail.bankCode || ''),
                    bankName: prevData ? prevData.bankName : (detail.bankName || ''),
                    // 优先使用作品信息中的单位和职称，其次是历史数据，最后是默认值
                    workUnit: userUnit || (prevData ? prevData.workUnit : (detail.workUnit || '')),
                    title: userZhicheng || (prevData ? prevData.title : (detail.title || '')),
                    payMoney: detail.payMoney || '', // 金额始终使用当前劳务的值
                    signDate: this.getCurrentDate(), // 默认设置为当前日期
                    signature: '',
                    lbCode: detail.lbCode || '',
                    projectId: detail.projectId || '',
                    // 专家劳务不需要作品ID，但我们保存一下以便后续处理
                    worksid: detail.worksId || '',
                    worksType: '',
                    worksName: '',
                    agreeId: detail.agreeId || '',
                    // 如果之前有上传过证件照片，也要复用
                    cardFrontFile: prevData ? prevData.cardFrontFile : '',
                    cardBackFile: prevData ? prevData.cardBackFile : '',
                    bankFile: prevData ? prevData.bankFile : '',
                    zhichengFile: prevData ? prevData.zhichengFile : '',
                    zigeFile: prevData ? prevData.zigeFile : '',
                    // 图片预览URL
                    cardFrontPreviewUrl: prevData && prevData.cardFrontFile ? prevData.cardFrontFile : '',
                    cardBackPreviewUrl: prevData && prevData.cardBackFile ? prevData.cardBackFile : '',
                    bankPreviewUrl: prevData && prevData.bankFile ? prevData.bankFile : '',
                    zhichengPreviewUrl: prevData && prevData.zhichengFile ? prevData.zhichengFile : '',
                    zigePreviewUrl: prevData && prevData.zigeFile ? prevData.zigeFile : ''
                };
                
                console.log('专家劳务签署表单初始数据:', this.signForm);
                
                // 显示弹窗
                this.signDialogVisible = true;
                this.signStep = 1;
                this.setCurrentDate(); // 设置当前日期
                
                // 清除之前的签名
                this.signatureImage = '';
            },
        }
    }
</script>
<style scoped>
    .Order {
        width: 100%;
        min-width: 910px;
    }

    .table-container {
        width: 100%;
        overflow-x: auto;
        background: #fff;
        border-radius: 4px;
        box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
        padding-bottom: 8px; /* 为滚动条预留空间 */
    }

    /* 自定义滚动条样式 */
    .table-container::-webkit-scrollbar {
        height: 8px;
        background-color: #f5f5f5;
    }

    .table-container::-webkit-scrollbar-thumb {
        background: #909399;
        border-radius: 4px;
    }

    .table-container::-webkit-scrollbar-thumb:hover {
        background: #606266;
    }

    .table-container::-webkit-scrollbar-track {
        background: #e4e7ed;
        border-radius: 4px;
    }

    .no-wrap-table {
        width: max-content !important;
        min-width: 100%;
    }

    /* 确保表头和单元格内容不换行 */
    ::v-deep .el-table th {
        text-align: center;
        white-space: nowrap !important;
        color: #303030;
        font-weight: bold;
        background-color: #f5f5f5;
    }

    ::v-deep .el-table td {
        text-align: center;
        white-space: nowrap !important;
    }

    ::v-deep .el-table .cell {
        white-space: nowrap !important;
        line-height: 23px;
    }

    .custom-text-size {
        font-size: 14px !important;
        text-align: center;
    }

    /* 分页器样式 */
    .PageDis {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 20px;
        background: #fff;
        margin-top: 20px;
        border-radius: 4px;
        box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
    }

    /* 操作按钮样式 */
    .operation-buttons {
        display: flex;
        align-items: center;
        justify-content: center;
        white-space: nowrap;
    }

    .operation-buttons .el-button {
        margin-right: 10px;
    }

    .operation-buttons .el-button:last-child {
        margin-right: 0;
    }

    /* 添加按钮样式 */
    .add-service {
        margin-bottom: 20px;
    }

    .add-service .el-button {
        background-color: #0385EB;
        border-color: #0385EB;
    }

    .add-service .el-button:hover {
        background-color: #0374d1;
        border-color: #0374d1;
    }

    .el-dialog__body {
        padding: 20px 30px;
    }

    .el-form-item {
        margin-bottom: 20px;
    }

    .Nav {
        flex: 1;
        display: flex;
        align-items: center;
    }

    .NavItem {
        font-size: 16px;
        flex: 1;
        padding: 15px 0;
        text-align: center;
        font-weight: 400;
        color: #666666;
        cursor: pointer;
        position: relative;
    }

    .NavItem.Act {
        color: #e69d26;
        /* font-weight: 600; */
    }

    .NavItem.Act::after {
        content: "";
        position: absolute;
        width: 100%;
        height: 2px;
        background: #e69d26;
        bottom: -2px;
        left: 0;
    }

    .NavMsg {
        color: #666;
        font-size: 16px;
    }

    @media only screen and (max-width: 768px) {
        .Order {
            min-width: auto;
            width: 100%;
        }
        .table-container {
            overflow-x: auto;
            box-shadow: none;
            border: 1px solid #ebeef5;
        }
        ::v-deep .el-table th {
            padding: 8px 0;
            font-size: 14px;
        }
        ::v-deep .el-table td {
            padding: 5px 0;
            font-size: 14px;
        }
        .ellipsis-cell {
            max-width: 100px;
        }
        .PageDis {
            padding: 15px 5px;
        }
        .NavItem {
            font-size: 14px;
            padding: 10px 5px;
        }
        ::v-deep .el-dialog {
            width: 95% !important;
            margin-top: 10vh !important;
        }
        ::v-deep .el-dialog__title {
            font-size: 16px;
        }
        ::v-deep .el-form-item__label {
            font-size: 14px;
        }
        ::v-deep .el-form-item {
            margin-bottom: 15px;
        }
        ::v-deep .el-button {
            padding: 8px 15px;
            font-size: 14px;
        }
        .operation-buttons .el-button {
            padding: 5px 10px;
            margin-right: 5px;
        }
    }

    .ellipsis-cell {
        max-width: 150px;
    }

    ::v-deep .ellipsis-cell .cell {
        width: 100%;
        padding: 0 8px;
    }

    .ellipsis-content {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        width: 100%;
    }

    ::v-deep .el-tooltip__popper {
        max-width: 50%;
        line-height: 1.5;
        padding: 8px 12px;
        font-size: 14px;
    }

    ::v-deep .el-table td:not(.ellipsis-cell) .cell {
        white-space: nowrap !important;
        overflow: visible !important;
        text-overflow: unset !important;
    }

    .authorization-content {
        padding: 20px;
    }

    .authorization-text {
        margin: 20px 0;
        line-height: 1.8;
    }

    .signature-area {
        display: inline-block;
        width: 180px;
        height: 60px;
        border: 1px dashed #ddd;
        vertical-align: middle;
        cursor: pointer;
        margin-left: 10px;
        background-color: #fff;
    }

    .signature-canvas {
        width: 500px;
        height: 200px;
        border: 1px solid #ddd;
        background-color: #fff;
    }

    .signature-actions {
        text-align: right;
    }

    .sign-dialog {
        .el-dialog__body {
            padding: 20px 30px;
        }
    }

    .sign-container {
        .Steps {
            display: flex;
            align-items: center;
            margin-bottom: 30px;
        }

        .StepsItem {
            flex: 1;
            height: 50px;
            line-height: 50px;
            text-align: center;
            background: #F5F5F5;
            position: relative;
            font-size: 16px;
            color: #999;
        }

        .StepsItem.Act {
            background: #58C1B6;
            color: #fff;
        }

        .mobile-steps {
            display: none;
        }
    }

    /* 弹窗样式优化 */
    ::v-deep .sign-dialog {
        .el-dialog {
            margin-top: 5vh !important;
            display: flex;
            flex-direction: column;
            max-height: 90vh;
        }
        
        .el-dialog__body {
            flex: 1;
            overflow-y: auto;
            overflow-x: hidden;
            max-height: calc(85vh - 120px);
            padding-bottom: 0;
        }
        
        .el-dialog__footer {
            padding: 10px 20px 20px;
            position: sticky;
            bottom: 0;
            background: #fff;
            z-index: 10;
            box-shadow: 0 -2px 10px rgba(0,0,0,0.1);
        }
    }

    /* 移动端优化 */
    @media screen and (max-width: 768px) {
        ::v-deep .sign-dialog {
            .el-dialog {
                width: 95% !important;
                margin: 5vh auto !important;
            }
            
            .el-dialog__body {
                padding: 15px;
                max-height: 70vh;
            }
            
            .el-dialog__footer {
                padding: 10px 15px 15px;
            }
        }
        
        .pc-only {
            display: none !important;
        }
        
        .mobile-only {
            display: block !important;
        }
        
        .mobile-steps {
            display: flex !important;
            justify-content: space-between;
            margin-bottom: 20px;
            padding: 0 10px;
        }
        
        .mobile-step {
            padding: 8px 12px;
            border-radius: 4px;
            background: #f5f5f5;
            color: #999;
            font-size: 14px;
            text-align: center;
        }
        
        .mobile-step.active {
            background: #0385EB;
            color: #fff;
        }
        
        .dialog-footer {
            margin-top: 20px;
            text-align: center;
        }
        
        .auth-content {
            margin-bottom: 20px;
        }
        
        .authorization-form {
            padding: 20px;
            font-size: 14px;
            width: 100%;
            min-width: auto;
            transform: none;
            margin-left: 0;
        }

        .agreement-title {
            font-size: 18px;
        }

        .payment-double-row {
            height: auto;
            margin-bottom: 25px;
        }
        
        .payment-double-row .left-info,
        .payment-double-row .right-info {
            position: static;
            width: 100%;
            margin-bottom: 10px;
            white-space: normal;
            word-break: break-all;
        }
        
        .signature-row {
            flex-direction: column;
        }
        
        .signature-col {
            max-width: 100%;
            margin-bottom: 20px;
        }

        .text-placeholder {
            min-width: 100px;
        }
        
        /* 确保签名框在移动端显示合适的大小 */
        .signature-area {
            width: 200px;
            height: 60px;
        }

        /* 确保签名弹窗在移动端正确显示 */
        .signature-modal-content {
            max-width: 95%;
        }

        /* 调整协议内容在移动端的显示 */
        .auth-content {
            padding: 10px;
            overflow-x: hidden;
        }
        
        /* 签名画布适配 */
        .signature-canvas {
            width: 100%;
            max-width: 300px;
            height: 150px;
        }
    }

    .authorization-form {
        max-width: 900px;
        margin: 0 auto;
        padding: 40px;
        font-size: 14px;
        line-height: 1.8;
        color: #333;
        background-color: #fff;
        border-radius: 8px;
        page-break-inside: avoid;
    }

    .agreement-title {
        text-align: center;
        font-size: 20px;
        font-weight: bold;
        margin-bottom: 30px;
    }

    .agreement-header {
        margin-bottom: 20px;
    }

    .agreement-section {
        margin-bottom: 20px;
        page-break-inside: avoid;
    }

    .agreement-section h3 {
        font-size: 16px;
        font-weight: bold;
        margin-bottom: 10px;
    }

    .indent {
        text-indent: 2em;
        margin-bottom: 10px;
        text-align: justify;
    }

    .sub-section {
        margin-bottom: 15px;
    }

    .text-placeholder {
        display: inline-block;
        min-width: 150px;
        border-bottom: 1px solid #999;
        text-align: left;
        margin: 0 5px;
        word-break: break-all;
        max-width: 300px;
    }

    .info-grid {
        margin-top: 10px;
    }

    .info-row {
        position: relative;
        margin-bottom: 20px;
        line-height: 1.8;
        word-break: break-all;
        page-break-inside: avoid;
    }

    .info-row p {
        margin: 0;
        line-height: 1.8;
        word-break: break-all;
    }

    .payment-double-row {
        position: relative;
        height: auto;
        clear: both;
        margin-bottom: 25px;
        page-break-inside: avoid;
    }

    .payment-double-row .left-info {
        position: static;
        width: 100%;
        margin-bottom: 10px;
        white-space: normal;
        word-break: break-all;
    }

    .payment-double-row .right-info {
        position: static;
        width: 100%;
        white-space: normal;
        word-break: break-all;
    }

    .agreement-footer {
        margin-top: 40px;
        page-break-inside: avoid;
    }

    .signature-row {
        display: flex;
        justify-content: space-between;
        page-break-inside: avoid;
    }

    .signature-col {
        flex: 1;
        max-width: 45%;
    }

    .signature-col p {
        margin-bottom: 15px;
        line-height: 1.8;
    }

    .signature-image {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }

    .signature-placeholder {
        display: inline-block;
        width: 100%;
        height: 100%;
        line-height: 50px;
        text-align: center;
        color: #999;
    }

    .signature-area {
        display: inline-block;
        width: 180px;
        height: 60px;
        border: 1px dashed #ddd;
        vertical-align: middle;
        cursor: pointer;
        margin-left: 10px;
        background-color: #fff;
    }

    .underline {
        text-decoration: underline;
    }
    
    /* 作品名称样式 */
    .works-name {
        font-weight: bold;
        text-decoration: underline;
        color: #333333;
        padding: 0 3px;
    }

    .signature-modal {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.5);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 9999;
    }

    .signature-modal-content {
        background: #fff;
        padding: 20px;
        border-radius: 8px;
        text-align: center;
        max-width: 90%;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        z-index: 10000;
    }

    .signature-buttons {
        margin-top: 20px;
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
    }

    .preview-image {
       max-width: 100px;
       max-height: 100px;
       margin-left: 10px;
       cursor: pointer;
       border: 1px solid #dcdfe6;
       border-radius: 4px;
       object-fit: contain;
    }

    /* 添加分页控制 */
    @media print {
        .authorization-form {
            page-break-before: auto;
            page-break-after: auto;
        }
        
        .agreement-section {
            page-break-before: auto;
            page-break-after: auto;
        }
        
        .info-row {
            page-break-before: auto;
            page-break-after: auto;
        }
        
        .payment-double-row {
            page-break-before: auto;
            page-break-after: auto;
        }
        
        .agreement-footer {
            page-break-before: auto;
            page-break-after: auto;
        }
        
        .signature-row {
            page-break-before: auto;
            page-break-after: auto;
        }
    }

    /* 修改去签署按钮颜色 */
    :deep(.el-button--primary) {
        background-color: #58C1B6 !important;
        border-color: #58C1B6 !important;
    }

    :deep(.el-button--primary:hover),
    :deep(.el-button--primary:focus) {
        background-color: #4BA89E !important;
        border-color: #4BA89E !important;
    }

    :deep(.el-button--primary:active) {
        background-color: #3E8F86 !important;
        border-color: #3E8F86 !important;
    }

    /* 其他样式保持不变 */
</style>